export default { lastUpdatedObjects: [] };
